import React from 'react';
import styled from 'styled-components';
import { SearchInput } from '../../SearchInput/SearchInput';
import { strings } from '../../localisation';

interface IOptionSearchProps {
    onSearchChange: (search: string) => Promise<void>;
}

export const OptionSearch = (props: IOptionSearchProps) => {
    return (
        <StyledLi>
            <SearchInput
                clearAriaLabel={strings.Label_ClearSearch}
                placeholder={strings.Label_Search}
                searchAriaLabel={strings.Label_Search}
                {...props}
            />
        </StyledLi>
    );
};

const StyledLi = styled.li`
    padding: 3px;
`;
